import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';

const CustomisedDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 15,
    [theme.breakpoints.up('sm')]: {
      borderRadius: 25,
    },
  },
}));

export default CustomisedDialog;
